import { useHttp } from "../http/useHttp";
import { useAxiosQuery } from "../http/useAxiosQuery";
import { useMemo } from "react";
import { paths } from "../generated-types";
import { useNavigate } from "react-router-dom";
import { ACCOUNT_LOGIN_PATH } from "../../paths";
import { useToast } from "@synota-io/synota-shared-ui";

type SelfOperation = paths["/dashboard/self"]["get"];
export type ISelf = SelfOperation["responses"][200]["content"]["application/json"];

export const useSelf = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const { client } = useHttp();
  const { status, isLoading, isPending, isFetching, data, error, refetch } = useAxiosQuery<ISelf>({
    queryKey: ["self"],
    queryFn: () => client.get("/self"),
    retry: (count, error) => {
      if (error.status === 401) {
        toast.warning("Your session expired, please login", {
          onClose() {
            navigate(ACCOUNT_LOGIN_PATH);
          },
        });
        return false;
      }
      return count < 3;
    },
    placeholderData: () => undefined,
  });

  return {
    status,
    isLoading,
    isPending,
    isFetching,
    self: useMemo(() => data?.data || null, [data?.data]),
    error,
    refetch,
  };
};

export type UseSelfReturn = ReturnType<typeof useSelf>;
